import { API } from "../urls";

/**
 * Panel araması: cari, firma, kullanıcı ve ödemelerde arar. Yetki sınırı
 * backend'de oturumdan çözülür, istekte firma/cari parametresi yoktur.
 *
 * @param {AbortSignal} [signal] tuş vuruşu eskidiğinde isteği iptal etmek için
 */
export const searchPanel = async (query, { limit = 5, signal } = {}) => {
    const res = await fetch(API.global_search(query, limit), {
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        signal,
    });
    if (!res.ok) throw new Error("Arama yapılamadı");
    const json = await res.json();
    return Array.isArray(json?.data) ? json.data : [];
};
